import { Exclude, Type } from 'class-transformer';
import {
  IsBoolean,
  IsDate,
  IsDefined,
  IsInt,
  IsOptional,
  IsString,
  Length,
} from 'class-validator';
import { NpsPieMerchantCreateDto } from './nps-pie-merchant-create.dto';

export class NpsCreateDto {
  @Exclude()
  id?: number;

  @IsDefined()
  @IsInt()
  @Type(() => Number)
  npsSurveyId: number;

  @IsDefined()
  @IsInt()
  @Type(() => Number)
  pieBrandId: number;

  @IsDefined()
  @IsString()
  @Length(1, 45)
  name: string;

  @IsDefined()
  @IsString()
  @Length(1, 255)
  description: string;

  @IsDefined()
  @IsString()
  @Length(1, 45)
  keyTerm: string;

  @Exclude()
  npsLink?: string;

  @IsOptional()
  @IsDate()
  @Type(() => Date)
  startDate?: Date;

  @IsOptional()
  @IsDate()
  @Type(() => Date)
  endDate?: Date;

  @IsOptional()
  @IsBoolean()
  isActive?: boolean;

  @Exclude()
  isOnline?: boolean;

  @IsOptional()
  @IsBoolean()
  isFollowUpEnabled?: boolean;

  @IsDefined()
  merchants?: NpsPieMerchantCreateDto[];

  @Exclude()
  createdDate?: Date;

  @Exclude()
  modifiedDate?: Date;
}
